import type { ParseKeys } from 'i18next';
import type { AppRoute } from '@/types';

export const NOTIFICATION_SEVERITY = {
  Critical: 'critical',
  Warning: 'warning',
  Info: 'info',
} as const;
export type NotificationSeverity =
  (typeof NOTIFICATION_SEVERITY)[keyof typeof NOTIFICATION_SEVERITY];

export interface Notification {
  id: string;
  severity: NotificationSeverity;
  /** `common`-namespace i18n key of the notification's title. */
  titleKey: ParseKeys<'common'>;
  /** `common`-namespace i18n key of the optional body text. */
  descriptionKey?: ParseKeys<'common'>;
  href: AppRoute;
  occurredAt: string;
  read: boolean;
}

export const LOCALE = {
  Nl: 'nl',
  En: 'en',
} as const;
export type Locale = (typeof LOCALE)[keyof typeof LOCALE];
